import { createFileRoute } from '@tanstack/react-router';

import { HourlyTuitionDraftsPage } from '~pages/payments/hourly-tuitions/drafts';

export const Route = createFileRoute(
  '/_auth/_layout/payment/hourly-tuition/drafts',
)({
  component: HourlyTuitionDraftsPage,
});
